// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"4131c567","213":"c770444d","608":"a76b1f3b","807":"56eb47f1"}[chunkId] + ".chunk.js";
};